import React from 'react';
import MaterialIcon from 'material-icons-react';

const CommonMessage = props => {

    const {errorContainerStyle, errorMessage} = styles;

    return (
        <div style={errorContainerStyle} className="errorIcon">
                <h5 style={errorMessage}>{props.message}</h5>
                <MaterialIcon icon={props.icon} color="#dbdadb" size={40} />
            </div>
    );
}

export default CommonMessage;

CommonMessage.defaultProps = {
    message: 'Error',
    icon: 'warning'
}

const styles = {
    errorContainerStyle: {
        marginTop: '25px',
        backgroundColor: '#fafafa',
        padding: '60px 10px 0 10px',
        height: 200,
        textAlign: 'center'
    },
    errorMessage: {
        color: "#c3c3c3"
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CommonMessage.js